// Centralized helpers for building workspace-scoped URLs

// ─── Detail pages (flat paths) ─────────────────────────────────────
export const workspaceTaskUrl = (workspaceId: string, taskId: string) =>
  `/workspaces/${workspaceId}/tasks/${taskId}`;

export const workspaceOutcomeUrl = (workspaceId: string, outcomeId: string) =>
  `/workspaces/${workspaceId}/outcomes/${outcomeId}`;

export const workspaceDecisionUrl = (workspaceId: string, decisionId: string) =>
  `/workspaces/${workspaceId}/decisions/${decisionId}`;

export const workspaceWorkflowInstanceUrl = (workspaceId: string, instanceId: string) =>
  `/workspaces/${workspaceId}/workflow-instances/${instanceId}`;

export const workspaceStakeholderUrl = (workspaceId: string, stakeholderId: string) =>
  `/workspaces/${workspaceId}/stakeholders/${stakeholderId}`;

export const workspacePersonUrl = (workspaceId: string, personId: string) =>
  `/workspaces/${workspaceId}/people/${personId}`;

export const workspaceProjectUrl = (workspaceId: string, projectId: string) =>
  `/workspaces/${workspaceId}/projects/${projectId}`;

export const workspaceTeamUrl = (workspaceId: string, teamId: string) =>
  `/workspaces/${workspaceId}/teams/${teamId}`;

// ─── Section pages ─────────────────────────────────────────────────
export const workspaceDashboardUrl = (workspaceId: string) =>
  `/workspaces/${workspaceId}/dashboard`;

export const workspaceYourWorkUrl = (workspaceId: string) =>
  `/workspaces/${workspaceId}/work`;

export const workspaceYourInterestsUrl = (workspaceId: string) =>
  `/workspaces/${workspaceId}/interests`;

export const workspaceDataExploreUrl = (workspaceId: string) =>
  `/workspaces/${workspaceId}/data/explore`;

export const workspaceWorkflowsUrl = (workspaceId: string) =>
  `/workspaces/${workspaceId}/data/workflows`;

export const workspaceSettingsUrl = (workspaceId: string) =>
  `/workspaces/${workspaceId}/workspace/settings`;

export const workspaceHistoryUrl = (workspaceId: string) =>
  `/workspaces/${workspaceId}/workspace/history`;

// ─── Generic helper ────────────────────────────────────────────────
export const workspaceRoute = (workspaceId: string, path: string) =>
  `/workspaces/${workspaceId}/${path.replace(/^\//, '')}`;
